import { message } from 'antd';
import { takeLatest, select } from 'redux-saga/effects';
import { getDistributionData } from '@api/metricContainer';
import * as actions from './actions';
import * as selectors from './selectors';
import * as types from './types';

import { autoRequest } from '@api/createRequestStore';

function* fetchingEngagement() {
  const query = yield select(selectors.querySelector);
  if (!query) {
    return;
  }
  try {
    yield autoRequest(getDistributionData, types.SCOPE, query)
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* watchFetchingEngagement() {
  yield takeLatest([
    actions.fetchingEngagement().type,
  ], fetchingEngagement);
}

export default [
  watchFetchingEngagement
];
